import { Link } from "react-router-dom";
import PageBanner from "../../PageBanner";
import SocialMediaSidebar from "../../SocialMediaSidebar";
import SectionHeader from "../../SectionHeader";
import ScrollToTopButton from "../../ScrollToTopButton";
import SectionHeaderNoPDF from "../../SectionHeaderNoPDF";

const OfferingGeoTrackingVehicles = () => {
  return (
    <>
      <div>
        <SocialMediaSidebar />
      </div>
      <PageBanner
        title="Geo-Tracking Vehicles"
        breadcrumb={[
          { label: "Home", href: "/" },
          { label: "Offerings" },
        ]}
      />
      <div className="max-w-6xl mx-auto p-4">
        <SectionHeaderNoPDF
          title="Geo-Tracking Vehicles @ AJEEVI"
          shareUrl="https://swmecom.ajeevi.in/geo-tracking"
        />
      </div>
      
      <div>
        <ScrollToTopButton />
      </div>

      {/* Page content */}
      <div className="w-full px-4 sm:px-6 md:px-10 lg:px-28 py-10 bg-white text-gray-800 text-justify">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          {/* Summary Section */}
          <div className="mb-10">
            <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
              Summary
            </h4>
            <p className="text-black mb-4 text-lg">
              Geo-tracking technology is transforming waste collection operations by providing real-time visibility of garbage trucks through GPS integration. This advanced monitoring ensures optimized collection routes, timely service, and efficient fleet management.
            </p>
            <p className="text-black text-lg">
              Municipalities and waste management companies leveraging geo-tracking achieve significant improvements in operational efficiency, fuel savings, and customer satisfaction while meeting environmental sustainability goals.
            </p>
          </div>

          {/* Introduction Section */}
          <div className="mb-10">
            <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
              Introduction
            </h4>
            <p className="text-black mb-4 text-lg">
              In today's smart cities, efficient waste collection requires more than just scheduled pickups. Geo-tracking systems provide the technological backbone for modern waste management fleets, offering unprecedented control and optimization of collection operations.
            </p>
            <p className="text-black text-lg">
              By equipping garbage trucks with GPS devices and connecting them to centralized monitoring platforms, waste management providers can track vehicle locations, monitor route adherence, and dynamically adjust collection schedules based on real-time data and traffic conditions.
            </p>
          </div>

          {/* Key Features Section */}
          <div className="mb-10">
            <h5 className="text-xl font-semibold mb-4 text-black">
              Key Features of Geo-Tracking Systems:
            </h5>
            <ul className="list-disc pl-6 space-y-2 text-lg text-black">
              <li>
                <strong>Real-Time Location Tracking:</strong> Precise GPS monitoring of all fleet vehicles on interactive maps
              </li>
              <li>
                <strong>Route Optimization:</strong> AI-powered algorithms that calculate the most efficient collection paths
              </li>
              <li>
                <strong>Performance Analytics:</strong> Detailed reports on vehicle utilization, idle time, and collection efficiency
              </li>
              <li>
                <strong>Automated Alerts:</strong> Instant notifications for route deviations, delays, or missed collections
              </li>
              <li>
                <strong>Historical Route Playback:</strong> Review past routes for performance analysis and incident investigation
              </li>
              <li>
                <strong>Integration with Bin Sensors:</strong> Combines vehicle tracking with smart bin data for responsive collections
              </li>
            </ul>
          </div>

          {/* Benefits Section */}
          <div className="mb-10">
            <h5 className="text-xl font-semibold mb-3 text-black">
              Operational Benefits
            </h5>
            <p className="text-black text-lg mb-4">
              Implementing geo-tracking delivers measurable improvements across all aspects of waste collection:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
              <li>15-30% reduction in fuel costs through optimized routing</li>
              <li>20-40% improvement in daily collection efficiency</li>
              <li>Real-time ETAs for customers and facility managers</li>
              <li>Reduced carbon emissions through minimized driving distances</li>
              <li>Enhanced accountability with digital proof of service</li>
              <li>Data-driven capacity planning for fleet expansion</li>
            </ul>
          </div>

          {/* Implementation Section */}
          <div className="mb-10">
            <h5 className="text-xl font-semibold mb-3 text-black">
              Implementation Considerations
            </h5>
            <p className="text-black text-lg mb-4">
              Successful geo-tracking deployment requires careful planning:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
              <li>Selection of rugged, vehicle-appropriate GPS hardware</li>
              <li>Integration with existing fleet management systems</li>
              <li>Staff training on monitoring platforms and data interpretation</li>
              <li>Gradual rollout with pilot vehicles before full fleet deployment</li>
              <li>Regular system calibration for optimal accuracy</li>
            </ul>
          </div>

          {/* Ajeevi's Contribution Section */}
          <div>
            <h5 className="text-xl font-semibold mb-3 text-black">
              Ajeevi's Geo-Tracking Solutions
            </h5>
            <p className="text-black mb-4 text-lg">
              Ajeevi provides comprehensive geo-tracking systems specifically designed for waste management:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
              <li>
                <strong>Advanced Fleet Tracking:</strong> Real-time monitoring with customizable geofences and alerts
              </li>
              <li>
                <strong>Route Optimization Engine:</strong> Dynamic routing based on traffic, weather, and collection priorities
              </li>
              <li>
                <strong>Integrated Waste Management Platform:</strong> Combines vehicle tracking with bin monitoring and workforce management
              </li>
              <li>
                <strong>Custom Reporting:</strong> Tailored analytics for operational KPIs and sustainability metrics
              </li>
              <li>
                <strong>Mobile Workforce App:</strong> Driver interface with turn-by-turn navigation and task management
              </li>
            </ul>
            <p className="text-black text-lg">
              Discover how Ajeevi's geo-tracking can revolutionize your waste collection operations. Visit{" "}
              <a
                href="http://www.ajeevi.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#00D084] hover:underline"
              >
                www.ajeevi.com
              </a>{" "}
              for more information.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default OfferingGeoTrackingVehicles;